module.exports = __webpack_public_path__ + "img/blue-90rotate-icon-01.58997b17.svg";